import { connect } from "react-redux";
import FeasibilityForm from "./feasibilityCheck";
import { addDemandAction } from "../../../../redux/actions/demand/demand.action";
import { openAlertPopup } from "../../../../redux/actions/Alert/alert.action";

const mapStateToProps = (state) => {
  return {
    myRights: state.myRights.myRights,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
   addDemandAction: (payload,id)=>{
            return dispatch(addDemandAction(payload,id))
        },
   openAlertPopup: (payload) => {
          return dispatch(openAlertPopup(payload))
        },
   
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FeasibilityForm);